"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuildImageStatus = exports.BuildSandboxDockerImageTask = exports.BuildSandboxDockerImageTaskData = exports.SandboxDockerImage = exports.SandboxDockerImageData = void 0;
var http_client_1 = require("./http_client");
var utils_1 = require("./utils");
var SandboxDockerImageData = /** @class */ (function () {
    function SandboxDockerImageData(args) {
        this.pk = args.pk;
        this.display_name = args.display_name;
        this.course = args.course;
        this.last_modified = args.last_modified;
    }
    return SandboxDockerImageData;
}());
exports.SandboxDockerImageData = SandboxDockerImageData;
var SandboxDockerImage = /** @class */ (function (_super) {
    __extends(SandboxDockerImage, _super);
    function SandboxDockerImage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SandboxDockerImage.get_images = function (course_id) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get(SandboxDockerImage._get_images_url(course_id))];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (item) { return new SandboxDockerImage(item); })];
                }
            });
        });
    };
    SandboxDockerImage.create_image = function (files, course_id, on_upload_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var form_data, files_1, files_1_1, file, response;
            var e_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        form_data = new FormData();
                        try {
                            for (files_1 = __values(files), files_1_1 = files_1.next(); !files_1_1.done; files_1_1 = files_1.next()) {
                                file = files_1_1.value;
                                form_data.append('files', file, file.name);
                            }
                        }
                        catch (e_1_1) { e_1 = { error: e_1_1 }; }
                        finally {
                            try {
                                if (files_1_1 && !files_1_1.done && (_a = files_1.return)) _a.call(files_1);
                            }
                            finally { if (e_1) throw e_1.error; }
                        }
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().post(SandboxDockerImage._get_images_url(course_id), form_data, { on_upload_progress: on_upload_progress })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, new BuildSandboxDockerImageTask(response.data)];
                }
            });
        });
    };
    SandboxDockerImage._get_images_url = function (course_id) {
        return course_id === null
            ? '/sandbox_docker_images/'
            : "/courses/" + course_id + "/sandbox_docker_images/";
    };
    SandboxDockerImage.get_by_pk = function (image_pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/sandbox_docker_images/" + image_pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new SandboxDockerImage(response.data)];
                }
            });
        });
    };
    SandboxDockerImage.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().patch("/sandbox_docker_images/" + this.pk + "/", utils_1.filter_keys(this, SandboxDockerImage.EDITABLE_FIELDS))];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        return [2 /*return*/];
                }
            });
        });
    };
    SandboxDockerImage.prototype.rebuild = function (files, on_upload_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var form_data, files_2, files_2_1, file, response;
            var e_2, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        form_data = new FormData();
                        try {
                            for (files_2 = __values(files), files_2_1 = files_2.next(); !files_2_1.done; files_2_1 = files_2.next()) {
                                file = files_2_1.value;
                                form_data.append('files', file, file.name);
                            }
                        }
                        catch (e_2_1) { e_2 = { error: e_2_1 }; }
                        finally {
                            try {
                                if (files_2_1 && !files_2_1.done && (_a = files_2.return)) _a.call(files_2);
                            }
                            finally { if (e_2) throw e_2.error; }
                        }
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().put("/sandbox_docker_images/" + this.pk + "/rebuild/", form_data, { on_upload_progress: on_upload_progress })];
                    case 1:
                        response = _b.sent();
                        return [2 /*return*/, new BuildSandboxDockerImageTask(response.data)];
                }
            });
        });
    };
    SandboxDockerImage.prototype.delete = function () {
        return http_client_1.HttpClient.get_instance().delete("/sandbox_docker_images/" + this.pk + "/");
    };
    SandboxDockerImage.EDITABLE_FIELDS = [
        'display_name',
    ];
    return SandboxDockerImage;
}(SandboxDockerImageData));
exports.SandboxDockerImage = SandboxDockerImage;
var BuildSandboxDockerImageTaskData = /** @class */ (function () {
    function BuildSandboxDockerImageTaskData(args) {
        this.pk = args.pk;
        this.created_at = args.created_at;
        this.status = args.status;
        this.return_code = args.return_code;
        this.timed_out = args.timed_out;
        this.filenames = args.filenames;
        this.course_id = args.course_id;
        this.image = args.image;
        this.validation_error_msg = args.validation_error_msg;
        this.internal_error_msg = args.internal_error_msg;
    }
    return BuildSandboxDockerImageTaskData;
}());
exports.BuildSandboxDockerImageTaskData = BuildSandboxDockerImageTaskData;
var BuildSandboxDockerImageTask = /** @class */ (function (_super) {
    __extends(BuildSandboxDockerImageTask, _super);
    function BuildSandboxDockerImageTask() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BuildSandboxDockerImageTask.get_build_tasks = function (course_id) {
        return __awaiter(this, void 0, void 0, function () {
            var url, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        url = course_id === null
                            ? '/image_build_tasks/' : "/courses/" + course_id + "/image_build_tasks/";
                        return [4 /*yield*/, http_client_1.HttpClient.get_instance().get(url)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data.map(function (item) { return new BuildSandboxDockerImageTask(item); }).sort(function (first, second) { return second.pk - first.pk; })];
                }
            });
        });
    };
    BuildSandboxDockerImageTask.get_by_pk = function (pk) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get("/image_build_tasks/" + pk + "/")];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new BuildSandboxDockerImageTask(response.data)];
                }
            });
        });
    };
    BuildSandboxDockerImageTask.prototype.get_output = function (on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/image_build_tasks/" + this.pk + "/output/", { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    BuildSandboxDockerImageTask.prototype.cancel = function () {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().post("/image_build_tasks/" + this.pk + "/cancel/")];
                    case 1:
                        response = _a.sent();
                        utils_1.safe_assign(this, response.data);
                        return [2 /*return*/];
                }
            });
        });
    };
    BuildSandboxDockerImageTask.prototype.get_files = function (on_download_progress) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, http_client_1.HttpClient.get_instance().get_file("/image_build_tasks/" + this.pk + "/files/", { on_download_progress: on_download_progress })];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, response.data];
                }
            });
        });
    };
    return BuildSandboxDockerImageTask;
}(BuildSandboxDockerImageTaskData));
exports.BuildSandboxDockerImageTask = BuildSandboxDockerImageTask;
var BuildImageStatus;
(function (BuildImageStatus) {
    BuildImageStatus["queued"] = "queued";
    BuildImageStatus["in_progress"] = "in_progress";
    BuildImageStatus["done"] = "done";
    BuildImageStatus["failed"] = "failed";
    BuildImageStatus["image_invalid"] = "image_invalid";
    BuildImageStatus["cancelled"] = "cancelled";
    BuildImageStatus["internal_error"] = "internal_error";
})(BuildImageStatus = exports.BuildImageStatus || (exports.BuildImageStatus = {}));
//# sourceMappingURL=sandbox_docker_image.js.map